import { motion } from "framer-motion";
import { Eyebrow, SerifH } from "./shared";
import { USPS } from "../data/content";

export function UspStrip() {
  return (
    <section id="shop" data-testid="usp-strip" className="bg-[#F4EDE2] text-[#0C111C]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-20 md:py-28 border-t border-b border-[#0C111C]/10">
        <Eyebrow>The YABA difference</Eyebrow>
        <SerifH className="mt-4" size="clamp(32px, 3.5vw, 56px)">
          Made by hand. Made to be worn.
        </SerifH>
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-8 gap-y-12">
          {USPS.map(({ Icon, label, sub }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
            >
              <Icon size={40} strokeWidth={1.25} className="text-[#4A3626]" />
              <p className="mt-5 text-lg" style={{ fontFamily: "Fraunces, serif" }}>
                {label}
              </p>
              <p className="mt-2 text-sm text-[#3A3A3E]" style={{ fontFamily: "Inter, sans-serif" }}>
                {sub}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
